<!-- ----------------------------------------------- -->
<template>
  <v-card id="rw-list" class="com-mb-dialog normal">
    <v-row class="com-mb-dialog-header">
      <span class="com-mb-dialog-title">発表情報一覧</span>
      <!-- 凡例 -->
      <v-tooltip
          v-if="this.tab === 0 || this.tab === 1"
          bottom
          max-width="350px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2"
              >help_outline</v-icon
            >
          </template>
          <!-- 洪水予報 -->
          <span v-if="this.tab === 0">
            {{ legendStr.fld.title }}
            <br />
            <span>
              <span>
                {{ legendStr.tmStg.tmStgMsg1 }}
                <br />
                {{ legendStr.tmStg.tmStgMsg2 }}
                <br />
              </span>
              <span class="text-flood-occurrence legend-stg-span mb-1">
                {{ legendStr.tmStg.occurrence }}
              </span>
              <br />
              <span class="text-flood-danger legend-stg-span mb-1">
                {{ legendStr.tmStg.danger }}</span
              >
              <br />
              <span class="text-flood-refuge legend-stg-span mb-1">
                {{ legendStr.tmStg.refuge }}
              </span>
              <br />
              <span class="text-flood-warn legend-stg-span mb-1">
                {{ legendStr.tmStg.warn }}
              </span>
            </span>
          </span>
          <!-- ダム放流通知 -->
          <span v-if="this.tab === 1">
            {{ legendStr.dam.title }}
            <br />
            {{ legendStr.dam.damMsg1 }}
            <br />
            {{ legendStr.dam.damMsg2 }}
          </span>
        </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn v-show="!isFull" small icon color="white" @click="expansionWindow">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn v-show="isFull" small icon color="white" @click="reductionWindow">
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents">
      <v-col class="com-mb-dialog-frame">
        <rw-list></rw-list>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 河川予警報一覧ダイアログ
 * RiverwarnList.vue
 * @author LIS
 */
import mixin from "./../../../lib/mixin.js";
import RwList from "../../../components/mb/RwList.vue";

export default {
  /** タグ名 */
  name: "mb-rw-list",
  mixins: [mixin],
  components: { RwList },
  data() {
    return {
      isFull: false,
      tab: 0,
    };
  },
  computed: {
    /**
     *  設定情報
     */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /**
     *  予警報種別
     */
    type: {
      get() {
        return this.$route.query["type"];
      },
    },
    /**
     * 凡例共通文言
     */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
  },
  mounted() {
    this.$log.debug("[RiverwarnList] mounted()");
    // パラメータによって初期表示するタブを変更
    let type = this.$route.query["type"];
    if (type === "fldfr") {
      this.tab = 0;
    } else if (type === "damdsch") {
      this.tab = 1;
    } else if (type === "fldctl") {
      this.tab = 2;
    }
  },
  /** メソッド */
  methods: {
    /** 画面拡大 */
    expansionWindow() {
      this.$log.debug("[RiverwarnList] expansionWindow()");
      var dlg = document.getElementById("rw-list");
      dlg.className = "com-mb-dialog large v-card v-sheet theme--light";
      this.isFull = true;
    },
    /** 画面縮小 */
    reductionWindow() {
      this.$log.debug("[RiverwarnList] reductionWindow()");
      var dlg = document.getElementById("rw-list");
      dlg.className = "com-mb-dialog normal v-card v-sheet theme--light";
      this.isFull = false;
    },
    /** 画面を閉じる */
    closeDlg() {
      this.$log.debug("[RiverwarnList] closeDlg()");
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
  },
  watch: {
    /** 予警報種別 */
    type() {
      this.$log.debug("[RiverwarnList] type()");
      if (this.type === "fldfr") {
        this.tab = 0;
      } else if (this.type === "damdsch") {
        this.tab = 1;
      } else if (this.type === "fldctl") {
        this.tab = 2;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 50%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
}

#rw-list {
  right: 4px;
}

.rw-span-warn {
  font-size: 10pt;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border-radius: 4px;
}

.rw-legend-img {
  width: 100%;
}
</style>
